const makes = [
  'Acura',
  'Audi',
  'BMW',
  'Buick',
  'Cadillac',
  'Chevrolet',
  'Chrysler',
  'Dodge',
  'Fiat',
  'Ford',
  'GMC',
  'Honda',
  'Hyundai',
  'Infiniti',
  'Jeep',
  'Kia',
  'Land Rover',
  'Lexus',
  'Mazda',
  'Mercedes Benz',
  'Mini',
  'Mistubishi',
  'Nissan',
  'RAM',
  'Subaru',
  'Toyota',
  'Volkswagen',
  'Volvo',
  'Other',
];

export default makes;
